import React from 'react';

const NoResults = () => (
  <div className="project-status-grid-item__no-results">No Results</div>
);

export default NoResults;
